export default {"src":"/_next/static/media/robert.cd8fa3d4.svg","height":554,"width":512,"blurWidth":0,"blurHeight":0};